/* Copyright (c) 2020-present CloudIO Inc */

import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Platform } from 'componentregistry';
import { MotionIconButton } from 'custom/Motion';
import { useDeveloperMode } from 'designer/atoms';
import Icon from 'icons/Icon';
import React, { useEffect, useState } from 'react';
import { useUserPagesStore } from 'store/utils/utils';
import PageMenu from './PageMenu';
import { atom, useStateXAtom } from '@cloudio-saas/statex';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    cursor: 'pointer',
    // marginLeft: theme.spacing(1),
  },
}));

export const refreshPageMenuAtom = atom({
  path: ['transient', 'refreshPageMenu'],
  defaultValue: false,
});

export default function PageMenuIcon({
  appUid,
  pageUid,
  layoutId = 'navbars',
  platform,
}: {
  pageUid: string;
  appUid: string;
  layoutId?: string;
  platform: Platform;
}): React.ReactElement | null {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const devMode = useDeveloperMode(appUid, pageUid);
  const store = useUserPagesStore();
  const [refresh, setRefresh] = useStateXAtom(refreshPageMenuAtom);
  useEffect(() => {
    if (open) {
      if (refresh) {
        store.refresh(true);
        setRefresh(false);
      }
    }
  }, [open, refresh, store]);

  return (
    <>
      {!open ? (
        <MotionIconButton
          key={`${devMode ? 'd-' : ''}navbars`}
          data-testid="navigation"
          layoutId={`${devMode ? 'd-' : ''}$${layoutId}`}
          className={classes.root}
          onClick={() => setOpen(!open)}
          data-tip="Navigation"
          aria-label="Navigation"
          initial={false}
          color={'inherit'}
        >
          <span aria-hidden="false" style={{ display: 'none' }}>
            Navigation
          </span>
          <Icon color={'inherit'} iconName="bars" />
        </MotionIconButton>
      ) : null}
      {open && (
        <PageMenu
          onClose={() => setOpen(false)}
          layoutId={`${devMode ? 'd-' : ''}$${layoutId}`}
          appUid={appUid}
          pageUid={pageUid}
          platform={platform}
        />
      )}
    </>
  );
}
